import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Generic
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import ProtectedRoute from './routing/ProtectedRoute';
import Statistics from './pages/Statistics/Statistics';
import Users from './pages/Users/Users';
import Stats from './pages/Users/Stats';
import Domains from './pages/Domains/Domains';
import Configurations from './pages/Configurations/Configurations';
import Orders from './pages/Orders/Orders';
import Plans from './pages/Plans/Plans';
import Articles from './pages/Articles/Articles';
import Jobs from './pages/Jobs/Jobs';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/dashboard/*" element={<ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>}>
            <Route path="statistics" element={<Statistics />} />
            <Route path="users" element={<Users />} />
            <Route path="orders" element={<Orders />} />
            <Route path="plans" element={<Plans />} />
            <Route path="users/stats/:id" element={<Stats />} />
            <Route path="domains" element={<Domains />} />
            {/* <Route path="articles" element={<Articles />} />
            <Route path="jobs" element={<Jobs />} /> */}
            <Route path="configurations" element={<Configurations />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;